import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {
  CommonFunctionsService,
  ApiService,
  DatastoreService,
  NotificationStoreService,
} from 'src/app/services/index';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  invalidLogin = false;
  submitted = false;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  hotlink = '';
  sso = false;
  companyId: number = 0;
  params: { site: string; comp: string };
  resetSubmitted = false;
  resetSuccess = false;
  forgotPassword = false;
  showPassword: boolean = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private apiserver: ApiService,
    public dataStore: DatastoreService,
    private notifStore: NotificationStoreService,
    private route: ActivatedRoute,
    private commFuncService: CommonFunctionsService,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}
  // Define the login form
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(this.emailRegex),
    ]),
    password: new FormControl('', Validators.required),
  });

  resetPasswordForm: FormGroup = new FormGroup({
    resetemail: new FormControl('', [
      Validators.required,
      Validators.pattern(this.emailRegex),
    ]),
  });
  // Getter for easy access to form fields
  get form() {
    return this.loginForm.controls;
  }
  get resetForm() {
    return this.resetPasswordForm.controls;
  }

  ngOnInit(): void {
    let authToken = localStorage.getItem('auth_token');
    let memberObject = localStorage.getItem('loginObject');
    const splitHref = window.location.href.split('/');
    if (splitHref[4].indexOf('#') !== -1) {
      splitHref[4] = splitHref[4].split('#')[0];
    }
    this.params = { site: splitHref[3], comp: splitHref[4] };
    console.log(authToken, memberObject);
    if (authToken != 'undefined' && memberObject) {
      this.alreadyLoggedIn(JSON.parse(memberObject));
      this.dataStore.authToken = authToken;
    }

    this.getConfig();
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  async getConfig() {
    const config = await this.commFuncService.setCompanyName(this.params);
    this.companyId = parseInt(config.company);
    if (config.hasOwnProperty('ceremony_officer_app')) {
      if (config.ceremony_officer_app.hasOwnProperty('sso_login')) {
        this.sso = !!config.ceremony_officer_app.sso_login;
      }
    }
    console.log('Using sso:', this.sso);
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        console.log('result', result);
        console.log('here1', result);
        // this.ssoLogin();
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        console.log(this.authService.instance);
        const accounts = this.authService.instance.getAllAccounts();
        console.log(accounts);
        if (accounts.length > 0) {
          this.ssoLogin(accounts[0]);
        }
        // No need to do anything here - user not logged in
      });
    // let requireLogn = config.requireLogin;
    // if (!(requireLogn)) {
    //   this.router.navigate(['/access'])
    // }
    // if (config.hasOwnProperty('sso') && config.sso) {
    //   this.sso = true;
    // }
  }

  login() {
    console.log(this.msalGuardConfig.authRequest);
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  alreadyLoggedIn(memberObject: any) {
    this.dataStore.loginObject = memberObject;
    if (memberObject['_embedded']) {
      if (memberObject['_embedded'].members.length >= 1) {
        this.dataStore.loginObject.member =
          memberObject['_embedded'].members[0];
      }
      if (memberObject['_embedded'].administrators.length >= 1) {
        this.dataStore.loginObject.member =
          memberObject['_embedded'].administrators[0];
      }
    }
    // set login on localstorage encase refresh
    localStorage.setItem('auth_token', this.dataStore.loginObject.auth_token);
    localStorage.setItem(
      'loginObject',
      JSON.stringify(this.dataStore.loginObject)
    );
    this.dataStore.loggedIn = true;
    this.notifStore.onsessionUpdate(true);
    console.log('here');
    this.router.navigate([
      `/${this.params.site}/${this.params.comp}/arrival/confirmed`,
    ]);
  }

  async onSubmit() {
    this.submitted = true;
    this.invalidLogin = false;
    // stop here if the login form is invalid
    console.log(this.sso);
    if (this.loginForm.invalid) {
      return;
    } else {
      if (this.sso) {
        try {
          const login: any = await this.apiserver.customSsoLogin(
            this.companyId,
            this.loginForm.value.email,
            'reference',
            this.loginForm.value.password
          );
          if (login == undefined) {
            this.invalidLogin = true;
          } else {
            this.dataStore.loginObject = login.message;
            if (this.dataStore.loginObject['_embedded']) {
              if (this.dataStore.loginObject['_embedded'].members.length >= 1) {
                this.dataStore.loginObject.member =
                  this.dataStore.loginObject['_embedded'].members[0];
              }
              if (
                this.dataStore.loginObject['_embedded'].administrators.length >=
                1
              ) {
                this.dataStore.loginObject.member =
                  this.dataStore.loginObject['_embedded'].administrators[0];
              }
            }
            this.dataStore.member = this.dataStore.loginObject.member;
            localStorage.setItem(
              'auth_token',
              this.dataStore.loginObject.auth_token
            );
            this.dataStore.authToken = this.dataStore.loginObject.auth_token;
            localStorage.setItem(
              'loginObject',
              JSON.stringify(this.dataStore.loginObject)
            );
            this.dataStore.loggedIn = true;
            console.log('here');
            this.router.navigate([
              `/${this.params.site}/${this.params.comp}/arrival/confirmed`,
            ]);
          }
        } catch (err) {
          console.log(err);
          this.invalidLogin = true;
        }
      } else {
        this.apiserver
          .login(this.loginForm.value)
          .then(async (response: any) => {
            console.log(response);
            if (response == undefined) {
              this.invalidLogin = true;
            } else {
              this.dataStore.loginObject = response;
              if (this.dataStore.loginObject['_embedded']) {
                if (
                  this.dataStore.loginObject['_embedded'].members.length >= 1
                ) {
                  this.dataStore.loginObject.member =
                    this.dataStore.loginObject['_embedded'].members[0];
                }
                if (
                  this.dataStore.loginObject['_embedded'].administrators
                    .length >= 1
                ) {
                  this.dataStore.loginObject.member =
                    this.dataStore.loginObject['_embedded'].administrators[0];
                }
              }
              this.dataStore.member = this.dataStore.loginObject.member;
              // set login on localstorage for refresh
              localStorage.setItem(
                'auth_token',
                this.dataStore.loginObject.auth_token
              );
              this.dataStore.authToken = this.dataStore.loginObject.auth_token;
              localStorage.setItem(
                'loginObject',
                JSON.stringify(this.dataStore.loginObject)
              );
              this.dataStore.loggedIn = true;
              console.log('here');
              this.router.navigate([
                `/${this.params.site}/${this.params.comp}/arrival/confirmed`,
              ]);
            }
          })
          .catch((error) => {
            if (
              error ||
              (error['response'] && error['response'].status === 401)
            ) {
              this.invalidLogin = true;
            }
          });
      }
    }
  }

  async ssoLogin(ssoAccount: any) {
    const nameParts = ssoAccount.name.split(' ');
    const ssoToken: any = await this.apiserver.generateSSOToken(this.commFuncService.getCompanyId(), nameParts[0], nameParts[1],ssoAccount.username);
    console.log(ssoToken);
    const loginObject = await this.apiserver.ssoLogin(this.commFuncService.getCompanyId(), ssoToken.token);
    console.log(loginObject);
    this.dataStore.loginObject = loginObject;
    if (this.dataStore.loginObject['_embedded']) {
      if (
        this.dataStore.loginObject['_embedded'].members.length >= 1
      ) {
        this.dataStore.loginObject.member =
          this.dataStore.loginObject['_embedded'].members[0];
      }
      if (
        this.dataStore.loginObject['_embedded'].administrators
          .length >= 1
      ) {
        this.dataStore.loginObject.member =
          this.dataStore.loginObject['_embedded'].administrators[0];
      }
    }
    this.dataStore.member = this.dataStore.loginObject.member;
    localStorage.setItem(
      'auth_token',
      this.dataStore.loginObject.auth_token
    );
    this.dataStore.authToken = this.dataStore.loginObject.auth_token;
    localStorage.setItem(
      'loginObject',
      JSON.stringify(this.dataStore.loginObject)
    );
    this.dataStore.loggedIn = true;
    console.log('here');
    this.dataStore.loggedInBySSO = true;
    this.router.navigate([
      `/${this.params.site}/${this.params.comp}/arrival/confirmed`,
    ]);

  }

  forgotPasswordToggle() {
    if (this.forgotPassword) {
      this.forgotPassword = false;
    } else {
      this.forgotPassword = true;
    }
  }

  sendReset() {
    this.resetSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      this.apiserver
        .passwordReset(
          this.resetPasswordForm.value.resetemail,
          this.params.comp
        )
        .then((res) => {
          this.resetSuccess = true;
        });
    }
  }
}
